export default class ApplicationStateHandler  {

    constructor() {
        this.onStateUpdate = (state) => {
            console.log(state);
        }
    }

    setOnStateUpdate(callback) {
        this.onStateUpdate = callback;
    }


    setQuestionValueState(state, sectionId, blockId, questionId, value) {

       let updated = Object.assign({}, state, {
            values : Object.assign({}, state.values? state.values: {}, {
                [this.generateKey(sectionId, blockId, questionId)]  : {
                    section_id: sectionId,
                    block_id : blockId,
                    question_id : questionId,
                    value : value
                }
            })
       });

       this.onStateUpdate(updated);
    }

    completeSection(state, sectionId, callback = () => {}) {
        const index = _.findIndex(state.completed_sections, s => {
            return s === sectionId;
        });


        if(index === -1) {

            let updatedSections = [...state.completed_sections];
            updatedSections.push(sectionId);
            let updated = Object.assign({}, state, {
                completed_sections: updatedSections
            });
            this.onStateUpdate(updated, callback);
        }
    }

    unCompleteSection(state, sectionId) {
        const index = _.findIndex(state.completed_sections, s => {
            return s === sectionId;
        });

        if(index !== -1) {
            let updatedSections = [...state.completed_sections];
            updatedSections.splice(index, 1);
            let updated = Object.assign({}, state, {
                completed_sections: updatedSections
            });

            this.onStateUpdate(updated);
        }
    }

    generateKey(sectionId, blockId, questionId) {
        return `${sectionId}${blockId}${questionId}`;
    }


    getQuestionValue(state, sectionId, blockId, questionId, defaultValue = null) {
        const key = this.generateKey(sectionId, blockId, questionId);
        return state.values[key] ? state.values[key].value : defaultValue;
    }

    toArray(state) {
        return _.map(state.values, item => item);
    }

    assignGrantNumbers(application) {
        let  a = {...application};
        let config = a.grant_version.config;
        let blocks = [];
        config.sections.forEach((section) => {
            section.blocks.forEach((block, blockIndex) => {
                blocks.push(block);
                block.number = blocks.length;
                block.questions.forEach((question, questionIndex) => {
                    question.number = `${block.number}.${questionIndex + 1}`;
                });
            });
        });

        return a;
    }

    setStateFromApplication(state, application){

        const updateApplication = this.assignGrantNumbers(application);

        const latestVersion = application.latest_application_versions[0];


        let values = {};

        latestVersion?.content.forEach(item => {
           values[this.generateKey(item.section_id, item.block_id, item.question_id)] = item;
        });

        let updated = Object.assign({}, state, {
            application : updateApplication,
            values : values,
            loaded : true,
            completed_sections: latestVersion.completed_sections ? latestVersion.completed_sections : []
        });

        this.onStateUpdate(updated);
    }



}
